import { NestedModel } from "../nestedmodel";
import { TsmApi } from "../../index";
import { debug_error } from "../../logger";
import has from "lodash/has";

export class DeltaResp extends NestedModel {
    constructor(props, attributes) {
        super(props, Object.assign({}, attributes));
    }

    getApi() {
        const url = new URL(this.parent.get('request_url').split(this.parent.url())[0]);
        const apiPath = url.pathname;
        return new TsmApi(apiPath);
    }

    save({ requestData }) {
        if (!requestData) {
            throw new Error('requestData is required');
        }

        const api = this.getApi();

        const poll = async (data) => {
            if (!has(data, 'taskResultInfo')) {
                return data;
            }
            return new Promise((resolve, reject) => {
                setTimeout(() => {
                    console.log('Polling:', data);
                    api.tasks.taskId(data.taskResultInfo.taskId).featureSetDeviceTask.fetch()
                        .then(poll)
                        .then(resolve)
                        .catch(reject);
                }, data.taskResultInfo.pollIntervalMs);
            });
        };


        // return super.save(attributes, options)
        return this.fetch({ method: 'POST', data: requestData })
            .then(poll)
            .catch(error => {
                debug_error(error);
                throw error;
            });
    }
}
